import { render, staticRenderFns } from "./CPIDescription.vue?vue&type=template&id=41669367&"
import script from "./CPIDescription.vue?vue&type=script&lang=js&"
export * from "./CPIDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports